export default
{
    description : 'Veuillez sélectionner un article ci-dessous.' ,
    disagree    : 'Fermer' ,
    empty       : 'Aucun article disponible.' ,
    fail        : 'Impossible de charger les articles, veuillez relancer un peu plus tard.',
    loading     : 'Chargement en cours...' ,
    search      : 'Rechercher un article ...' ,
    title       : 'Sélectionner un article'
};
